import { useEffect } from 'react';
import { useResourceUserDetailsContext } from '../ResourceUserDetailsContext';
import { RESOURCE_USER_DETAILS_ACTION } from './resourceUserDetailsAction';

export const NUDGE_TYPE_KEY = {
  SKILL_NUDGES: 'skillNudges',
  CERTIFICATE_NUDGES: 'certificateNudges'
};

export const useRegisterGlobalNudgesCallback = ({
  nudgeTypeKey,
  editable,
  onAccept,
  onReject
}) => {
  const { dispatch } = useResourceUserDetailsContext();

  useEffect(() => {
    dispatch({
      type: RESOURCE_USER_DETAILS_ACTION.GLOBAL_NUDGES_UPDATE_CALLBACK,
      globalNudges: {
        [nudgeTypeKey]: {
          editable,
          onAccept,
          onReject
        }
      }
    });

    return () =>
      dispatch({
        type: RESOURCE_USER_DETAILS_ACTION.GLOBAL_NUDGES_UPDATE_CALLBACK,
        globalNudges: {
          [nudgeTypeKey]: null
        }
      });
  }, [dispatch, nudgeTypeKey, editable, onAccept, onReject]);
};

export default useRegisterGlobalNudgesCallback;
